"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFilteredUserTypes = exports.USER_TYPE_TEXT = exports.getUserName = void 0;
const domain_1 = require("@home-health-notify/domain");
const config_1 = require("../i18n/config");
const getUserName = (user) => {
    const name = user ? user.firstName + " " + user.lastName : "";
    const designation = user && user.designation ? ` - ${user.designation.shortHand}` : "";
    return name + designation;
};
exports.getUserName = getUserName;
exports.USER_TYPE_TEXT = {
    [domain_1.USER_TYPE.USER]: config_1.resources.en.userDirectory.userTypes.clinician,
    [domain_1.USER_TYPE.STAFF]: config_1.resources.en.userDirectory.userTypes.staff,
    [domain_1.USER_TYPE.PATIENT]: config_1.resources.en.userDirectory.userTypes.patient,
    [domain_1.USER_TYPE.PHYSICIAN]: config_1.resources.en.userDirectory.userTypes.physician,
    [domain_1.USER_TYPE.ADMIN]: config_1.resources.en.userDirectory.userTypes.admin,
};
const getFilteredUserTypes = (canAddExternalUsers, loggedInUserType) => {
    const isAdmin = loggedInUserType === domain_1.USER_TYPE.ADMIN;
    const filteredUserTypes = Object.keys(exports.USER_TYPE_TEXT).filter(key => canAddExternalUsers ||
        (key !== domain_1.USER_TYPE.PATIENT && key !== domain_1.USER_TYPE.PHYSICIAN));
    return isAdmin
        ? filteredUserTypes.filter(type => type !== domain_1.USER_TYPE.ADMIN)
        : filteredUserTypes;
};
exports.getFilteredUserTypes = getFilteredUserTypes;
